import { Link } from 'react-router-dom';

export default function NotFound(): JSX.Element {
  return (
    <section style={{ padding: 'var(--sp-7)', textAlign: 'center' }}>
      <p
        style={{
          fontFamily: 'var(--font-mono)',
          color: 'var(--pfl-magenta-bright)',
          fontSize: 'var(--fs-10)',
          letterSpacing: '0.18em',
        }}
      >
        404
      </p>
      <h1 style={{ marginTop: 'var(--sp-3)' }}>Route not found</h1>
      <p style={{ color: 'var(--pfl-text-mute)' }}>
        That path isn&rsquo;t part of the workspace.
      </p>
      <Link to="/dashboard">Return to dashboard</Link>
    </section>
  );
}
